import { useContext } from "react";
import StateContext from "../../state/stateContext";
import Shimmer from "../Shimmer/Shimmer";
import useQueryChildData from "../Hooks/useQueryChildData";
import useQueryCommitment from "../Hooks/useQueryCommitment";

export function wrapWebPublishableData(WrappedComponent, opts = {}) {
  const { shimmerProps = {} } = opts;

  return (props) => {
    const { ...componentProps } = props;
    const context = useContext(StateContext);
    const queryCommitment = useQueryCommitment(context);
    const queryChildData = useQueryChildData(context);

    const checkWebPublishable = (childData) => {
      // Do need to wait for commitment data
      if (
        childData.webPublishableFlag &&
        !childData.webPublishableRestrictionsFlag
      ) {
        return "true";
      } else if (!childData.webPublishableFlag) {
        return "false";
      }

      // Pending - means webPublishableRestrictionsFlag is true and webPublishableFlag is true, but it requires a successfull call to get commitment by guid
      return "pending";
    };

    const isWaiting =
      queryChildData.isWaiting ||
      (checkWebPublishable(queryChildData.data) === "pending" &&
        queryCommitment.isWaiting);

    const showShimmer = isWaiting;

    if (showShimmer) {
      return (
        <Shimmer
          className={`${shimmerProps?.classList || ""}`}
          isLoading={true}
          height={shimmerProps.height}
          {...shimmerProps}
        />
      );
    }

    // Apply Webpublishable Logic Here
    const childMedia = ((childData, isCommitmentSuccess) => {
      const result = checkWebPublishable(childData);

      if (result === "true") {
        // Available For All Users
        return childData.childMedia;
      } else if (result === "pending" && isCommitmentSuccess) {
        // Available For Users With Successful Commitment By Guid Call - Meaning the user is auth'd and matched sponsorship commitment
        return childData.childMedia;
      }

      // This Assumes Webpublishable is either false or User does not sponsor the child with guid
      return [];
    })(queryChildData.data, queryCommitment.isSuccess);

    return (
      <WrappedComponent
        {...componentProps}
        childMedia={childMedia}
        childData={queryChildData.data}
      />
    );
  };
}
